import * as React from 'react'
import Box from '@mui/material/Box'
import { FixedSizeList, FixedSizeListProps } from 'react-window'
import { styled } from '@mui/material'

const StyledList = styled(FixedSizeList)(() => ({
  flex: 1,
  maxHeight: 'calc(100vh - 204px)',
  scrollbarWidth: 'thin'
}))

/**
 * IListProps interface that defines the properties for the VirtualizedList component.
 * It extends FixedSizeListProps but overrides height and width to be optional.
 */
interface IListProps extends Omit<FixedSizeListProps, 'height' | 'width'> {
  /** The height and width of the list */
  height?: number | string
  /** The width of the list */
  width?: number | string
}

/**
 * VirtualizedList component
 * This component renders a virtualized list using react-window.
 * It allows for efficient rendering of large lists by only rendering visible items.
 * @param {IListProps} props - The properties for the VirtualizedList component.
 * @returns {JSX.Element} The rendered VirtualizedList component.
 */
const VirtualizedList: React.FC<IListProps> = ({ height, width, ...props }) => {
  return (
    <Box display='flex'>
      <StyledList
        {...props}
        height={height ? height : window.innerHeight}
        width={width ? width : window.innerWidth}
      />
    </Box>
  )
}

export default VirtualizedList
